module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 12 21",
      url: __webpack_public_path__ + "svg-sprite-fef6f85605acbf641cce7cd75d6011b0.svg#facebook",
      toString: function () {
        return this.url;
      }
    }